import compact from "lodash/compact";
import mapValues from "lodash/mapValues";
import { generatePath, type PathParam } from "react-router";

/**
 * @example
 * RouteTable.user.path -> "/user/:id"
 * RouteTable.user(3) -> "/user/3"
 */
export const RouteTable = defineRoutes({
  dashboard: "/",
  users: "/users",
  login: "/login",
  register: "/register",
  setPassword: "/set-password",
  changePassword: "/change-password",
  metabase: "/metabase",
});

export type RouteKey = keyof typeof RouteTable;

type QueryParams = ConstructorParameters<typeof URLSearchParams>[0];
type RouteFn<Path extends string> = { path: Path } & (PathParam<Path> extends never
  ? (search?: QueryParams) => string
  : (params: Record<PathParam<Path>, string | null>, search?: QueryParams) => string);

function defineRoutes<const T extends Record<string, string>>(routes: T) {
  return mapValues(routes, (path) => {
    const fn = ((params?: Record<PathParam<typeof path>, string | null>, search?: QueryParams) =>
      compact([
        params ? generatePath(path, params) : path,
        search ? new URLSearchParams(search).toString() : null,
      ]).join("?")) as RouteFn<typeof path>;

    fn.path = path;
    return fn;
  }) as { [K in keyof T]: RouteFn<T[K]> };
}
